import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
declare var jQuery: any;
import { SharedServiceService } from 'app/services/shared-service.service';
import { DepoitsService } from 'app/components/deposits/depoits.service';

@Component({
  selector: 'app-destination-deposit',
  templateUrl: './destination-deposit.component.html',
  styleUrls: ['./destination-deposit.component.scss']
})
export class DestinationDepositComponent implements OnInit {

  selectedDeposit;
  @Input() getDeposit;
  savedDestinationDeposits = [];
  @Input() hasError;
  isInvalid = false;
  @Input() hideList = false;
  @Output() notifyParent: EventEmitter<any> = new EventEmitter();
  @Input() title = 'سپرده مقصد (شماره سپرده با - وارد شود)';
  constructor(private sharedService: SharedServiceService, private depositService: DepoitsService) { }

  ngOnInit(): void {
    this.savedDestinationDeposits = JSON.parse(sessionStorage.getItem('destinationDeposits'));
    if (this.savedDestinationDeposits === null) {
      this.getDestinationDeposits();
    }
    if (this.getDeposit !== undefined) {
      this.selectedDeposit = this.getDeposit.depositNumber;
    }
  }
  sendParentNotification(index) {
    this.isInvalid = false;
    this.selectedDeposit = this.savedDestinationDeposits[index].depositNumber;
    const selectedDeposit = { ...this.savedDestinationDeposits[index] };
    this.notifyParent.emit(selectedDeposit);
    jQuery('#deposits').modal('hide');
  }
  depositPattern(event) {
    this.selectedDeposit = this.sharedService.convertToEnglishNumber(this.selectedDeposit);
    const temp = this.selectedDeposit.split('-');
    if (temp.length !== 4) {
      this.isInvalid = true;
      this.notifyParent.emit(-1);
    } else {
      this.isInvalid = false;
      jQuery('#selectedDeposit').blur();
      this.notifyParent.emit(this.selectedDeposit);
    }
  }
  getDestinationDeposits() {
    const temp = JSON.parse(sessionStorage.getItem('destinationDeposits'));
    if (temp === null) {
      this.depositService.getDestinationDeposits().subscribe(
        res => {
          if (res.code === 0) {
            this.savedDestinationDeposits = res.content;
            sessionStorage.setItem('destinationDeposits', JSON.stringify(res.content));
          }
        }
      );
    }
  }
}
